export enum SuggestionType {
  Wallet = 'wallet',
  Investment = 'investment',
  Redeem = 'redeem'
}
